import { useEffect, useState } from "react";
import { api, assetUrl } from "@/lib/api";
import { BeforeAfter } from "@/components/BeforeAfter";

export const VersionsCompare = ({ visionId, width, height, refresh }) => {
  const [list, setList] = useState([]);
  useEffect(() => { api.get(`/visions/${visionId}/compare`).then((r) => setList(r.data)).catch(() => {}); }, [visionId, refresh]);
  const concept = [...list].reverse().find((x) => !x.withProducts);
  const grounded = [...list].reverse().find((x) => x.withProducts);
  if (!concept || !grounded) return null;
  const full = grounded.kind === "Product Grounded";
  return (
    <section className="mt-16" data-testid="versions-compare">
      <div className="eyebrow mb-2">Compare</div>
      <h2 className="font-display text-3xl tracking-tight">{full ? "Conceptual vs Product Grounded" : "Conceptual vs with verified products"}</h2>
      <p className="mt-1 mb-4 text-sm text-[var(--stone-dark)]" data-testid="versions-compare-note">V{concept.number} imagined freely · V{grounded.number} rendered with verified products&apos; reference images{full ? "" : ` — ${grounded.kind}`}. Drag to compare.</p>
      <BeforeAfter before={assetUrl(concept.url)} after={assetUrl(grounded.url)} width={width} height={height} beforeLabel={`Conceptual · V${concept.number}`} afterLabel={`${full ? "Product Grounded" : "Verified products"} · V${grounded.number}`} />
    </section>
  );
};
